<template>
  <div id="detail">
    <vue-data-loading :loading="loading" :completed="completed" :listens="['infinite-scroll']" :init-scroll="true" @infinite-scroll="infiniteScroll">
      <div class="detail-list">
        <div class="detail-item" v-for="item in alist" :key="item.id" @click="goDetail(item.id)">
          <div class="detail-item-img">
              <img :src="item.imgUrl ? url + item.imgUrl : defaultimg" />
          </div>
          <p class="detail-item-name">{{item.title}}</p>
          <p class="detail-item-price">¥{{item.price}}</p>
        </div>
      </div>
      <img class="empty" src="/static/img/mescroll-empty.png" v-show="show">
      <div slot="infinite-scroll-loading">loading...</div>
      <div slot="completed">已无最新商品</div>
    </vue-data-loading>
  </div>
</template>

<script>
// 引入上拉加载组件
import VueDataLoading from 'vue-data-loading'
import url from '@/common/common.js'
export default {
  name: 'StoreDetail',
  components: {
    VueDataLoading // 注册VueDataLoading组件
  },
  data () {
    return {
      loading: false,
      completed: false,
      num: 1,
      size: 10,
      alist: [],
      show: false,
      url,
      defaultimg: '/static/img/defaultimg.jpg' // 默认图片
    }
  },
  methods: {
    fetchData () {
      this.loading = true
      this.getStorDetailInfo()
    },
    goDetail (id) {
      this.$router.push({
        path: '/detail/' + id
      })
    },
    infiniteScroll () {
      this.fetchData()
      this.num++
    },
    getStorDetailInfo () {
      // 联网请求
      this.axios.get('/ApiStore/GetList', {
        params: {
          id: decodeURIComponent(this.$route.query.shopid),
          num: this.num, // 页码
          size: this.size
        }
      }).then(this.getStorDetailInfoSucc)
        .catch(this.getStorDetailInfoFail)
    },
    getStorDetailInfoSucc (res) {
      res = res.data
      if (res.ret && res.data) {
        const data = res.data
        // this.list.push(JSON.parse(data.detailList))
        var newList = JSON.parse(data.detailList)
        if (this.num === 0) {
          this.completed = false
          this.loading = false
          this.show = true
        } else {
          for (var i = 0; i < newList.length; i++) {
            this.alist.push(newList[i])
          }
        }
        this.loading = false
        if (newList.length < this.size) {
          this.completed = true
          this.loading = false
        }
      }
      // console.log(newList)
    },
    getStorDetailInfoFail (err) {
      alert(err)
    }
  }
}
</script>

<style scoped>
.vue-data-loading >>>.loading-header{ display: none!important;}
.empty{ display: block; margin: 0 auto; width: 100%;}
.mess{  display: flex; flex-direction: column; justify-content: space-between; width: 74%;}
.detail{ overflow: hidden; border-bottom: 5px solid #f2f2f2; padding: 13px 15px; display: flex;}
.detail img{ float: left; border-radius: 5px; margin-right: 10px; width: 80px; height: 80px;}
.detail h5{ font-weight: normal; color: #333;}
.detail p{ font-size: 12px; padding-top: 3px; color: #656565;}
.detail a{ text-decoration: none;}
.dollars{ display: block; padding-top: 3px; font-size: 12px;}
.price{ font-size: 14px;}
.shop{ display: flex; justify-content: space-between; color: #e66221;}
.shop .iconfont{ font-size: 20px; color: #e66221; display: none;}
.mess-title{ background-color: rgb(255,255,255,0.5); border-bottom: 1px solid rgb(255,255,255,0.5);}
.detail-list{
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.detail-item{
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 12px 0 10px;
  margin-bottom: 8px;
  width: 49%;
  background: #FFFFFF;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.05);
  border-radius: 5px;
  box-sizing: border-box;
}
.detail-item-img{
  width: 145px;
  height: 145px;
  border-radius: 5px;
  overflow: hidden;
}
.detail-item-img img{
  width: 100%;
  height: 100%;
}
.detail-item-name{
  margin: 5px 0 10px;
  width: 140px;
  font-size: 12px;
  font-weight: bold;
  color: #333;
}
.detail-item-price{
  width: 140px;
  font-size: 12px;
  font-weight: 400;
  color: #DD1F00;
}
</style>



// WEBPACK FOOTER //
// src/pages/my_store/common/detail/Detail.vue